module.exports = __webpack_public_path__ + "img/yw2.88acaef3.png";